import React from 'react';
import Plans from './container/Plans';
import { Routes, Route, useLocation } from 'react-router-dom';
import Success from './components/Sucess';
import { PAGE_URLS } from './common/Constants';

const App = () => {
  const location = useLocation();
  return (
    <Routes>
      <Route path="/" element={<Plans location={location} />} />
      <Route path={PAGE_URLS.API_PLAN_CHECKOUT} element={<Plans location={location} />} />
      <Route path="/success" element={<Success />} />
    </Routes>
    // <CustomCard />
    // <Front />
  );
};

export default App;
